import React from "react";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

function Delete({ deletePopup, setDeletePopUp, DeleteNovel, sent }) {
  return (
    <div>
      <div
        className={
          deletePopup
            ? "px-[15px] md:px-0 fixed inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[50%] h-full md:h-[50%] xl:h-[50%] 2xl:h-[50%] m-auto bg-tertiary flex justify-center items-center flex-col -translate-y-[0%] opacity-100 duration-500 ease-in-out"
            : "px-[15px] md:px-0 fixed inset-x-0 inset-y-0 z-[1000] w-full md:w-full lg:w-[75%] xl:w-[60%] 2xl:w-[50%] h-full md:h-[50%] xl:h-[50%] 2xl:h-[50%] m-auto bg-tertiary flex justify-center items-center flex-col -translate-y-[-200%] opacity-0 duration-500 ease-in-out"
        }
      >
        <div
          onClick={() => setDeletePopUp(false)}
          className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
        >
          <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
        </div>
        <div className="max-w-[500px] space-y-4 h-auto flex justify-center items-center flex-col text-center">
          <h2 className="font-size">Delete for all eternity?</h2>
          <div className="capitalize space-y-4">
            <p className="text-[14px] md:text-[16px] font-SoraR">
              you'll lose all responses collected by this novel. i can't recover
              them for you once you delete.
            </p>
            <p className="text-[14px] md:text-[16px] font-SoraR">
              are you sure you want to permanently delete this novel?
            </p>
          </div>
        </div>
        <div className="sm:gap-x-4 gap-y-4 mt-8 font-SoraR flex justify-center items-center flex-wrap w-full">
          <button
            onClick={() => setDeletePopUp(false)}
            className="text-[14px] md:text-[16px] uppercase w-full sm:w-1/2 md:w-[120px] h-[50px] border-[1px] border-secondary hover:bg-secondary duration-500 ease-in-out hover:text-tertiary"
          >
            Cancel
          </button>
          <button
            onClick={DeleteNovel}
            className="uppercase w-full sm:w-1/2 md:w-[120px] h-[50px] bg-error hover:bg-error/90 duration-500 ease-in-out Red-btn-effect relative text-tertiary"
          >
            {sent ? (
              <div className="flex justify-center items-center scale-75">
                <div role="status">
                  <svg
                    aria-hidden="true"
                    className="mr-2 w-8 h-8 text-tertiary animate-spin fill-error"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    ></path>
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    ></path>
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="text-[14px] md:text-[16px]">Delete</div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Delete;
